import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gvkc6qnpt8: FaireBrandEntity = {
  token: "b_gvkc6qnpt8",
  type: "brand",
  name: "Handmade Jewels",
  avatarUrl:
    "https://cdn.faire.com/fastly/6c70531b09596b4b576d3a8182cddb82a9f1231f725e59fe45fbb2e9f2020134.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/50034ee0b3cdf7b0dbc4eec6e525c6bdf6440dc7d67525d50a0fd8ae438b6ae9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6c70531b09596b4b576d3a8182cddb82a9f1231f725e59fe45fbb2e9f2020134.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/50034ee0b3cdf7b0dbc4eec6e525c6bdf6440dc7d67525d50a0fd8ae438b6ae9.jpeg",
  location: "NJ, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 18,
  isTopShop: true,
  isInsider: false,
  description:
    "HandmadeJewels is the soul of artisanal craftsmanship brought to life under the legacy of 'Kirti Lapidary Exports Private Limited', a trusted name in natural gemstone exports. What began as a gemstone-cutting atelier has blossomed into a boutique jewelry brand that celebrates raw beauty, intentional design, and the magic of handmade.\n\nRooted in Jaipur—India’s gemstone capital—we design and craft each piece by hand, using ethically sourced, natural gemstones paired with sterling silver, brass, and gold-plated metals. Our style blends the free-spirited essence of boho with a touch of everyday chic, making our jewelry feel both personal and versatile.\n\nWith over two decades of experience in the gemstone trade, we ensure transparency, consistency, and craftsmanship in every order. Today, HandmadeJewels is proud to serve over 200 small retailers, metaphysical stores, and boutique brands across the U.S., UK and Europe.\n\nWhether you’re curating for modern minimalists or gemstone lovers drawn to spiritual healing, our collection offers authenticity with a global sensibility—each piece telling a story, each stone holding energy.\n\nWe’re not just a jewelry brand—we’re gemcutters, storytellers, and co-creators of your retail journey.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:33.720Z",
    importedBy: "entity-db-cli",
  },
};
